import { AxiosRequestConfig } from 'axios';
import { UploadFilesProps } from './report-damage.types';

class ReportDamageRequestConfig {
  uploadFiles = ({ files, schadenAufnahmeId, documentTypeId }: UploadFilesProps): AxiosRequestConfig => {
    const data = new FormData();
    files.forEach(file => {
      data.append('files', file, file.name);
    });
    data.append('schadenAufnahmeId', schadenAufnahmeId);
    data.append('documentTypeId', documentTypeId);

    return {
      method: 'POST',
      url: 'schadenmelden/uploadFiles',
      responseType: 'blob',
      data
    };
  };
}

export const reportDamageRequestConfig = new ReportDamageRequestConfig();
